const updates = [
  {
    date: '2026-07-31',
    title: '《流浪地球3》预告片首发上线',
    desc: '备受期待的国产科幻巨制《流浪地球3》首支预告片已在97影视独家上线，速来围观。',
    tag: '新片上线',
  },
  {
    date: '2026-07-30',
    title: '暑期热门剧集专题更新',
    desc: '新增《长安十二时辰2》《破冰行动2》等暑期热播剧高清资源，同步更新至最新集。',
    tag: '专题更新',
  },
  {
    date: '2026-07-28',
    title: '播放线路全面升级',
    desc: '平台CDN节点扩容完成，新增多条高速播放线路，观影流畅度大幅提升，秒播体验再优化。',
    tag: '平台升级',
  },
  {
    date: '2026-07-26',
    title: '经典港片高清修复版上线',
    desc: '《英雄本色》《纵横四海》《重庆森林》等经典港片4K修复版上线，重温黄金年代。',
    tag: '经典上线',
  },
  {
    date: '2026-07-24',
    title: '国漫专区内容扩充',
    desc: '新增《深海2》《哪吒3》等国产动画电影资源，国漫专区已收录超过500部精品动画。',
    tag: '内容扩充',
  },
  {
    date: '2026-07-22',
    title: '移动端体验优化',
    desc: '手机和平板观看体验全面优化，适配更多设备分辨率，加载速度提升40%。',
    tag: '体验优化',
  },
  {
    date: '2026-07-20',
    title: '纪录片频道重磅上线',
    desc: '全新纪录片频道正式上线，涵盖自然、历史、科技、人文等主题，高清画质探索世界。',
    tag: '新频道',
  },
  {
    date: '2026-07-18',
    title: '搜索功能智能升级',
    desc: '搜索引擎全面升级，支持模糊搜索、拼音搜索和演员关联搜索，找片更便捷。',
    tag: '功能更新',
  },
  {
    date: '2026-07-15',
    title: '日韩剧集专区上线',
    desc: '新增日韩剧集专属频道，收录热门日剧韩剧资源，同步更新中文字幕高清版。',
    tag: '新专区',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            97影视平台更新、内容上线与功能优化一手资讯
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-px bg-background-300/80"></div>
          <div className="space-y-6 md:space-y-8">
            {updates.map((update, i) => (
              <div key={i} className="relative flex gap-4 md:gap-6 pl-10 md:pl-12">
                <div className="absolute left-0 top-1.5 w-[10px] h-[10px] md:w-[12px] md:h-[12px] rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                <div className="flex-1 bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="px-2.5 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                      {update.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{update.date}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950">
                    {update.title}
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {update.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}